/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import type { ReactNode } from "react";
import type { TextFieldAria } from "react-aria";
import { cssFns } from "@superweb/css";
import { useUiColors } from "../theme";
import { useTypo } from "../typo";

/**
 * Component for display description for input field.
 * @internal
 * Used in components of various input fields.
 */
export const FieldDescription = ({
  descriptionProps,
  variant = "default",
  children,
}: {
  /**
   * Props for description tag
   */
  descriptionProps?: TextFieldAria["descriptionProps"];

  /**
   * Visual emphasis of the description.
   */
  variant?: "default" | "warning";

  /**
   * Localized description text
   */
  children: ReactNode;
}) => {
  const typo = useTypo();
  const uiColors = useUiColors();

  return (
    <div
      css={{
        ...cssFns.padding("0", "16px"),
        paddingBlockStart: "4px",
        ...typo({
          level: "caption1",
          density: "tight",
          weight: "regular",
        }),
        color:
          variant === "warning"
            ? uiColors.statuses.warning
            : uiColors.textMinor,
      }}
      {...descriptionProps}
    >
      {children}
    </div>
  );
};
